<template>
	<div class="boolean-label" :comment="settings.title">
		<i v-if="_modelValue === true" :class="['fas fa-check-circle', { 'text-success': settings.useColors }]"></i>
		<i v-else-if="_modelValue === false" :class="['fal fa-times-circle', { 'text-danger': settings.useColors }]"></i>
		<i v-else :class="['fal fa-minus-circle', { 'text-gray': settings.useColors }]"></i>
	</div>
</template>

<script>
	import _ from 'lodash'

	export default {
		props: {
			modelValue: { type: Boolean, default: false },
			options: {}
		},
		mounted() {
			if (this.params?.options) {
				this.settings = _.merge(this.settings, this.params.options)
				this._modelValue = this.settings.modelValue
			}
		},
		data() {
			return {
				_modelValue: false,
				settings: {
					useColors: true
				}
			}
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.merge({}, this.settings, val)
				}
			},
			modelValue: {
				immediate: true,
				handler(val) {
					this._modelValue = val
				}
			},
		}
	}
</script>
<style>
	div.boolean-label:hover::after {
		content: attr(comment);
		/*color: blue;*/
		/*margin-top: 3px;*/
		position: absolute;
		top: 25px;
		right: 0px;
		border-bottom: 0 none transparent;
		padding: 0px 10px 0px 10px;
		border-radius: 6px;
		background-color: white;
		box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.25);

	}
</style>
